import { SearchOutlined } from '@ant-design/icons';
import { Input, Space } from 'antd';
import React, { useState, useRef } from 'react';
import styles from './index.module.less';

const SearchInput = ({
  onChangeKeyword,
  onChangeFlag,
  onChangeSelectedIndustry,
}) => {
  const inputRef = useRef(null);
  const [value, setValue] = useState('');
  const showSearch = () => {
    if (value.trim() !== '') {
      onChangeFlag(true);
      onChangeSelectedIndustry(null);
      onChangeKeyword(value);
    }
  };
  return (
    <Space
      className={styles.headerSearch}
      direction='vertical'
      size={0}
    >
      <div className={styles.inputContainer}>
        <Input
          value={value}
          className={styles.input}
          size='small'
          ref={inputRef}
          placeholder={'Search...'}
          onChange={e => {
            setValue(e.target.value);
          }}
          onPressEnter={showSearch}
          allowClear
          suffix={
            <span
              className={styles.searchInputContainer}
              onClick={showSearch}
            >
              <SearchOutlined
                key='Icon'
                style={{
                  fontSize: 27,
                  cursor: 'pointer',
                  color: '#b5b5b5',
                  margin: 'auto',
                }}
              />
            </span>
          }
        />
      </div>
    </Space>
  );
};

export default SearchInput;
